import React, { useEffect, useState } from "react";

//Material Icons
import { Add, Cancel, Inventory } from "@mui/icons-material";

//UI Material
import {
  Button,
  CircularProgress,
  Grid,
  Stack,
  SwipeableDrawer,
  Typography,
} from "@mui/material";

//Local components
import Form from "../basics/Form";
import ModalWindow from "../Modal";

//Helpers
import { fetchWithTokenJSONPost } from "../../Helpers/network";

//Constants
import { currencies } from "../../Constants/currencies";

export default function SetItemDrawer({
  isNewItem = true,
  existingItemData = {},
  open,
  setOpen,
  getData,
}) {
  // ==========>Component States<==========
  //State for categories list
  const [categoriesList, setCategoriesList] = useState([]);
  //State for productData
  const [itemData, setItemData] = useState({});
  //State for setting loader
  const [isLoading, setIsLoading] = useState(false);
  //State for open modal
  const [modalOpen, setModalOpen] = useState(false);
  //State for modal text
  const [modalText, setModalText] = useState("");
  //State for modal description
  const [modalDescription, setModalDescription] = useState("");

  //The useEffect checks for token validation
  useEffect(() => {
    getCategoriesList();
  }, []);

  const addItemForm = [
    {
      selection: "textfield",
      id: "name",
      initialValue: itemData.name,
      xs: 12,
      md: 6,
      label: "Nombre del ítem",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Nombre del ítem",
      content: [],
      style: {},
    },
    {
      selection: "selector",
      id: "category",
      initialValue: itemData.category,
      xs: 12,
      md: 6,
      label: "Categoría de ítem",
      multiline: false,
      type: null,
      inputProps: {},
      placeholder: "",
      content: categoriesList.map((cat) => cat.name),
      style: { minWidth: "100%" },
    },
    {
      selection: "textfield",
      id: "additionalCode",
      initialValue: itemData.additionalCode,
      xs: 12,
      md: 6,
      label: "Identificador adicional",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Identificador adicional",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "location",
      initialValue: itemData.location,
      xs: 12,
      md: 6,
      label: "Estante",
      multiline: true,
      type: "text",
      inputProps: {},
      placeholder: "Estante",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "specifications",
      initialValue: itemData.specifications,
      xs: 12,
      md: 6,
      label: "Especificaciones",
      multiline: true,
      type: "text",
      inputProps: {},
      placeholder: "Especificaciones",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "recommendedStock",
      initialValue: itemData.recommendedStock,
      xs: 12,
      md: 6,
      label: "Stock recomendado",
      multiline: false,
      type: "number",
      inputProps: {},
      placeholder: "Stock recomendado",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "restockFrequency",
      initialValue: itemData.restockFrequency,
      xs: 12,
      md: 6,
      label: "Frecuencia de re-stock",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Frecuencia de re-stock",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "estimatedPriceOfSale",
      initialValue: itemData.estimatedPriceOfSale,
      xs: 12,
      md: 6,
      label: "Precio de venta estimado",
      multiline: false,
      type: "number",
      inputProps: {},
      placeholder: "Precio de venta estimado",
      content: [],
      style: {},
    },
    {
      selection: "selector",
      id: "currency",
      initialValue: itemData.currency,
      xs: 12,
      md: 6,
      label: "Tipo de moneda",
      multiline: false,
      type: null,
      inputProps: {},
      placeholder: "",
      content: currencies,
      style: { minWidth: "100%" },
    },
  ];

  //Function to get items list
  const getCategoriesList = async () => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        `/inventory/get-categories`,
        {
          howMany: 2500,
        }
      );
      const jsonResponse = await requestResponse.json();
      if (requestResponse.status === 200) {
        setCategoriesList(jsonResponse.data);
      } else {
        if (requestResponse.status === 401) {
          window.location.href = "/";
        }
      }
    } catch (error) {
      // setDataError(false);
    }
  };

  //Function to create new item
  const setItem = async () => {
    setIsLoading(true);

    const newItem = {
      id: existingItemData.id,
      name: itemData.name,
      category: categoriesList[itemData.category].name,
      categoryPrefix: categoriesList[itemData.category].prefix,
      additionalCode: itemData.additionalCode,
      specifications: itemData.specifications,
      location: itemData.location,
      recommendedStock: itemData.recommendedStock,
      restockFrequency: itemData.restockFrequency,
      estimatedPriceOfSale: itemData.estimatedPriceOfSale,
      currency: currencies[itemData.currency],
    };

    try {
      const requestResponse = await fetchWithTokenJSONPost(
        isNewItem ? "/inventory/create-item" : "/inventory/edit-item",
        newItem
      );
      const jsonResponse = await requestResponse.json();

      if (jsonResponse.status === "ok") {
        setModalText(
          isNewItem
            ? "Ítem registrado exitosamente."
            : "Ítem editado exitosamente."
        );
        setModalDescription(jsonResponse.description);
        getData();
        setOpen(false);
      } else {
        setModalText("No se pudo realizar la acción.");
        setModalDescription(jsonResponse.description);
      }
    } catch (error) {
      console.log(error);
    }
    setModalOpen(true);
    setIsLoading(false);
  };

  useEffect(() => {
    if (existingItemData && Object.keys(existingItemData).length > 0) {
      setItemData({
        name: existingItemData.name || "",
        category: 0,
        additionalCode: existingItemData.additionalCode || "",
        specifications: existingItemData.specifications || "",
        location: existingItemData.location || "",
        recommendedStock: existingItemData.recommendedStock || 0,
        restockFrequency: existingItemData.restockFrequency || "",
        estimatedPriceOfSale: existingItemData.estimatedPriceOfSale || 0,
        currency: currencies.indexOf(existingItemData.currency || 0),
      });
    }
  }, [existingItemData]);

  return (
    <SwipeableDrawer
      anchor="bottom"
      transitionDuration={600}
      disableSwipeToOpen={true}
      open={open}
      sx={{
        zIndex: "99",
        "& .MuiDrawer-paper": {
          justifyContent: "center",
          borderRadius: "35px 35px 0px 0px",
        },
      }}
      onClose={() => setOpen(false)}
      onOpen={() => {
        /**empty arrow function */
      }}
    >
      <Grid
        container
        justifyContent="center"
        sx={{ padding: "15px" }}
        textAlign="center"
        spacing={1}
      >
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <Inventory color="secondary" />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h7" fontWeight="bold" color="secondary">
            {isNewItem ? `Nuevo ítem` : `Editar información del ítem`}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Form data={addItemForm} handleStateChange={setItemData} />
        </Grid>
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <Stack direction="row" spacing={1} justifyContent="center">
            <Button
              size="small"
              variant="contained"
              color="error"
              sx={{ color: "white" }}
              endIcon={<Cancel />}
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancelar
            </Button>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <Button
                size="small"
                variant="contained"
                color="secondary"
                sx={{ color: "white" }}
                endIcon={<Add />}
                disabled={itemData.name === ""}
                onClick={setItem}
              >
                {isNewItem ? "Registrar ítem" : "Guardar cambios"}
              </Button>
            )}
          </Stack>
        </Grid>
      </Grid>
      <ModalWindow
        isOpen={modalOpen}
        handleClose={() => setModalOpen(false)}
        title={modalText}
        text={modalDescription}
        leftText="OK"
        leftClick={() => {
          setModalOpen(false);
        }}
      />
    </SwipeableDrawer>
  );
}
